import useNFTChain from 'hooks/useNFTChain';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const AssetPage = () => {
    const router = useRouter();
    const { assetId } = router.query;
    const { systemId } = useNFTChain();

    useEffect(() => {
        if (assetId) {
            const tokenId = Array.isArray(assetId) ? assetId[0].split(':')[1] : assetId.split(':')[1];
            router.replace(`/asset/${systemId}:${tokenId}`);
        }
    }, [assetId, router]);

    return null;
}

export default AssetPage;
